import styled from '@emotion/styled'
import { themeColor, stylesIf } from 'utils/styles'
import { DrawerRow } from 'components/patterns/Drawer/Drawer.style'
import { Header, Table } from 'components/patterns'

export const FooterStyled = styled(DrawerRow)`
  width: 100%;
  border-top: 1px solid ${(props) => props.theme.basicBoxBorderColor};
  padding-top: 10px;
  margin-bottom: 10px;
  background: ${(props) => props.theme.basicBoxBackgroundColor};
  text-align: center;
`.withComponent('footer')

export const ArticleStyled = styled(DrawerRow)`
  overflow-x: hidden;
  overflow-y: auto;
  flex-grow: 1;
  padding: 25px 18px !important;
  background-color: rgba(251, 251, 251, 1);
  border-top: .search-input-group {
    margin: 0;
  }
  .paged-table {
    margin: 10px 0;
  }

  .ant-table-thead > tr > th {
    height: 55px;
    padding: 8px !important;
  }
  .ant-table-tbody > tr > td {
    vertical-align: middle;
    height: 35px;
    padding: 0 8px !important;
  }
`.withComponent('article')

export const StyledHeader = styled(Header)`
  margin-top: 0;
  padding: 25px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #e3e5e8;
`

export const ConflictsHeader = styled.div`
  border-bottom: 1px solid ${themeColor('grey')};

  ${StyledHeader} {
    margin: 25px 18px !important;
    padding: 0;
    border-bottom: none;
  }
`

export const ConflictsBody = styled.div`
  background-color: ${themeColor('modalGrey')};
  padding: 16px 18px;
  height: 100vh;
`

export const CenterMiddlePositionWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 200px);
`

export const ConflictsOverViewContainer = styled.div`
  width: 661px;
  height: 309px;
`

export const ConflictsOverViewHeader = styled(Header)`
  margin-bottom: 17px;
`

export const ConflictsSummary = styled.div(
  (props) => `
    width: 661px;
    height: 62px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 22px 16px;
    background: ${themeColor('whitePrimary', props)};
    border-left: 1px solid ${themeColor('grey', props)}; 
    border-right: 1px solid ${themeColor('grey', props)};
    ${stylesIf(
      !props.hideTopBorder,
      `border-top: 1px solid ${themeColor('grey', props)};`
    )}
  
    ${stylesIf(
      props.last,
      `border-bottom: 1px solid ${themeColor('grey', props)};`
    )}

    div:first-of-type p {
      display: inline;
      margin-left: 16px;
    }

    ${stylesIf(
      props.disabled,
      `
      opacity: 0.5;
      cursor: default;

      button {
        cursor: default !important;
      }
    `
    )}

  `
)

export const FeatureConflictSubHeader = styled(Header)`
  margin-top: 35px;
`

export const TableHeader = styled.div`
  margin-top: 16px;
`

export const StyledFeatureTable = styled(Table)`
  margin-top: 25px;
`

export const StyledCurrentLimitWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
`

export const WarningIcon = styled.img`
  width: 20px;
  height: 18px;
`

export const ConflictResolveContainer = styled.div`
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
`
